/** @format */
import { lazy } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  useLocation,
} from 'react-router-dom';
import Home from '../Components/Pages/Home/Home';
import Index from '../Components/Pages/Entry/Index';
import LoginPage from '../Components/Pages/Login/Login.jsx';
import ForgotPasswordEmail from '../Components/Pages/Login/ForgotPasswordEmail.jsx';
import ResetPassword from '../Components/Pages/Login/ResetPassword.jsx';
import UserInfoGate from '../Components/Routes/UserInfoGate';
import { useLoginAuth } from '../hooks/Auth.jsx';
import { canAccessPage } from '../Constants/commons';
import Settings from '../Components/Pages/Settings/Settings.jsx';
import FileStat from '../Components/Pages/Settings/DataDetails/FileStat.jsx';
import AskAi from '../Components/Pages/askai/AskAi.jsx';

const DrillDown = lazy(() => import('../Components/Pages/Drilldown/DrillDown'));
const DataTree = lazy(() => import('../Components/Pages/DataTree/DataTree'));
const Benchmark = lazy(
  () => import('../Components/Pages/PerformanceCom/Benchmark.jsx')
);
const BizBarometr = lazy(
  () => import('../Components/Pages/BizBarometr/BizBarometr.jsx')
);
const BizExpense = lazy(
  () => import('../Components/Pages/BizExpense/BizExpense.jsx')
);
const BizProfit = lazy(
  () => import('../Components/Pages/BizProfit/BizProfit.jsx')
);
const BizForecast = lazy(
  () => import('../Components/Pages/BizForecast/BizForecast.jsx')
);
const BizBudgetComparison = lazy(
  () =>
    import('../Components/Pages/BizBudgetComparison/BizBudgetComparison.jsx')
);

const BizKPIs = lazy(() => import('../Components/Pages/KPIs/Kpi.jsx'));
const VarianceModule = lazy(
  () => import('../Components/Pages/VarianceModule/VarianceModule.jsx')
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Index />
          </PrivateRoute>
        }
      >
        <Route
          path="/home"
          index
          element={
            <PrivateRoute>
              <UserInfoGate>
                <Home />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/drill-down"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <DrillDown />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/data-tree"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <DataTree />
              </UserInfoGate>
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/benchmark"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <Benchmark />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/ask-ai"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <AskAi />
              </UserInfoGate>
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/biz-barometr"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizBarometr />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/biz-expense"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizExpense />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/biz-profit"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizProfit />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/forecast"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizForecast />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/budget-comparison"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizBudgetComparison />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/biz-kpis"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <BizKPIs />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/variance-module"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <VarianceModule />
              </UserInfoGate>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <UserInfoGate>
                <Settings />
              </UserInfoGate>
            </PrivateRoute>
          }
        ></Route>

        <Route path="/settings/file-stat" element={<FileStat />} />
      </Route>

      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </>
  )
);

function PrivateRoute({ children }) {
  const isUserLogged = useLoginAuth();
  const location = useLocation();

  if (!isUserLogged) {
    return <Navigate to="/login" replace={true} />;
  }

  if (!canAccessPage(location.pathname)) {
    return <Navigate to="/home" replace={true} />;
  }

  return children;
}

export default router;
